import { SendRounded } from '@mui/icons-material';
import {
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineSeparator,
} from '@mui/lab';
import { Avatar, IconButton, InputAdornment, InputBase } from '@mui/material';
import { useState } from 'react';
import { useAuthInfo } from '@propelauth/react';
import { useTranslation } from 'react-i18next';

// TODO: add images and rich text functionality

const AddActivity = ({ onSubmit }) => {
    const { t } = useTranslation();
    const [value, setValue] = useState('');

    const authInfo = useAuthInfo();

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (value) onSubmit(value).then(() => setValue(''));
        }
    };

    return (
        <TimelineItem>
            <TimelineSeparator>
                <TimelineDot sx={{ p: 0, border: 0 }}>
                    <Avatar
                        sx={{
                            width: 32,
                            height: 32,
                        }}
                        src={authInfo.user?.pictureUrl}
                    />
                </TimelineDot>
            </TimelineSeparator>
            <TimelineContent sx={{ width: '100%' }}>
                <InputBase
                    fullWidth
                    multiline
                    maxRows={4}
                    minRows={1}
                    placeholder={t('Write a note or update') + '...'}
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    sx={{
                        backgroundColor: 'surfaceContainer.main',
                        ':focus-within': {
                            backgroundColor: 'surfaceContainerHigh.main',
                        },
                        padding: 1.5,
                        borderRadius: 2,
                        borderTopLeftRadius: 0,
                        flexDirection: 'column',
                    }}
                    endAdornment={
                        <InputAdornment
                            position="end"
                            sx={{
                                alignSelf: 'flex-end',
                                my: 1.5,
                            }}
                        >
                            <IconButton
                                color="primary"
                                disabled={!value}
                                onClick={() => {
                                    onSubmit(value).then(() => setValue(''));
                                }}
                            >
                                <SendRounded />
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </TimelineContent>
        </TimelineItem>
    );
};

export default AddActivity;
